import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://xanders.online";
const SITE_NAME = "Xanders Staycations";
const OG_IMAGE = "https://customer-assets.emergentagent.com/job_affordable-staycay/artifacts/fv9ylmo3_FB%20PAGE.jpg";

export default function Seo({ title, description, path = "/", image = OG_IMAGE, type = "website" }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Cozy stays near SM Mall of Asia & SM Southmall`;
  const url = `${SITE_URL}${path === "/" ? "" : path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
